import Splide from "@splidejs/splide";
import {Lightbox} from "./pswp";

window.addEventListener("load", () => {
    const gallery_slides = document.querySelectorAll<HTMLElement>(".gallery-splide");
    const post_slides = document.querySelectorAll<HTMLElement>(".post-splide");

    gallery_slides.forEach(gallery => {
        const splide = new Splide(gallery, {
            type: 'loop',
            perPage: 4,
            perMove: 1,
            gap: '20px',
            arrows: true,
            pagination: true,
            breakpoints: {
                575: {
                    perPage: 2
                },
                767: {
                    perPage: 3
                }
            }
        });

        splide.on('mounted', () => {
            new Lightbox(gallery);
        });

        splide.mount();
    })

    post_slides.forEach(posts => {
        const splide = new Splide(posts, {
            type: 'slide',
            perPage: 3,
            perMove: 1,
            gap: '20px',
            arrows: true,
            pagination: true,
        });

        splide.mount();
    });
});
